import useChatPanelStore from '@module/stores/useChatPanelStore';
import { BaseRightArrow } from '@module/svg/icons';

interface Props {
  behavior: 'open' | 'close';
}

function ChatPanelButton({ behavior }: Props) {
  const { openChatPanel, closeChatPanel } = useChatPanelStore((s) => ({
    openChatPanel: s.openChatPanel,
    closeChatPanel: s.closeChatPanel,
  }));

  const id = behavior === 'open' ? 'open-chat-panel' : 'close-chat-panel';

  return (
    <button
      id={id}
      data-gtm-chat-panel={behavior}
      type='button'
      className='flex h-[42px] w-[42px] items-center justify-center rounded-l-[8px] border-borderBg01 border-y border-l bg-baseBg hover:bg-colorBg01'
      aria-label='채팅 접기'
      onClick={(e) => {
        e.stopPropagation();
        if (behavior === 'open') {
          openChatPanel();
        } else {
          closeChatPanel();
        }
      }}
    >
      <BaseRightArrow
        style={{
          fontSize: 6,
          color: 'var(--colorIco09)',
          transform: behavior === 'open' ? 'scale(-1, 1)' : undefined,
        }}
      />
    </button>
  );
}

export default ChatPanelButton;
